import React, {useCallback, useEffect} from 'react';
import ENDPOINT from '../../../constants/endpoints';
import AsyncCardsSelect from '../../../GbsUI/components/AsyncCardsSelect';

const SchoolPage = ({history, state, updateState, clearSavedState}) => {
  const onSchoolSelect = useCallback((school) => {
    updateState({
      data: {
        school: school,
      },
    });
  }, [updateState]);

  useEffect(() => {
    updateState({
      canContinue: !!state.data.school || !!state.data.schoolCustom,
      onContinue: () => {
        history.push('/student/signup');
      }
    });
  }, [state.data.school, state.data.schoolCustom]);

  useEffect(() => {
    clearSavedState();
  }, [])

  return (
    <>
      <h1 className={'student-signup__title student-signup__title--small student-signup__title--left'}>WELCOME RECENT GRADUATES</h1>
      <p className={'student-signup__description student-signup__description--left'}>First, select your undergraduate college or university</p>
      <div className={'student-signup__content-wrap'}>
        <AsyncCardsSelect
          selected={state.data.school}
          onChange={onSchoolSelect}
          source={ENDPOINT.STUDENT.SCHOOLS}
          createNewTitle={'Can\'t find your school in the list?'}
          createNewSubtitle={'Select your University NOT your business school or program (select UPenn, not Wharton).'}
          createNewHelp={'If your University or College is not listed, you can manually add it above.'}
          createNewPlaceholder={'e.g. University of Virginia'}
          notFoundText={'School is not found'}
          searchPlaceholder={'Enter your undergraduate university'}
          creatable
        />
      </div>
    </>
  );
};

export default SchoolPage;
